import { render } from "./BodyView.vue?vue&type=template&id=dcaff5fc"
import script from "./BodyView.vue?vue&type=script&lang=js"
export * from "./BodyView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.25_vue@3.5.25_webpack@5.103.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__